import { render, staticRenderFns } from "./Homeset.vue?vue&type=template&id=1b311b22&scoped=true&"
import script from "./Homeset.vue?vue&type=script&lang=js&"
export * from "./Homeset.vue?vue&type=script&lang=js&"
import style0 from "./Homeset.vue?vue&type=style&index=0&id=1b311b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b311b22",
  null
  
)

export default component.exports